export enum ConstructionSpecType {
  CONSTRUCTION = 'construction',
  UNCHANGED = 'unchanged',
  UNKNOWN = 'unknown',
  YEAR_OF_REHABILITATION = 'year-of-rehabilitation'
}
